import React from 'react';

export default function OpenOsV2ContratoVencModal({ v }) {
  const modal = v && v.contratoVencModal;
  if (!modal || !modal.dateLabel) return null;

  const title = modal.expired ? 'Contrato vencido' : 'Contrato prestes a vencer';
  const prefix = modal.expired
    ? 'O contrato deste equipamento já está vencido. Data de vencimento: '
    : 'O contrato deste equipamento vence em 30 dias ou menos. Data de vencimento: ';

  return (
    <div
      className="oosv2-contrato-venc-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="oosv2-contrato-venc-title"
      onClick={v.closeContratoVencModal}
    >
      <div className="oosv2-contrato-venc-card" onClick={(e) => e.stopPropagation()}>
        <div className="oosv2-contrato-venc-icon" aria-hidden="true">!</div>
        <div id="oosv2-contrato-venc-title" className="oosv2-contrato-venc-title">{title}</div>
        <div className="oosv2-contrato-venc-text">
          {prefix}
          <strong>{modal.dateLabel}</strong>
          .
        </div>
        <button
          type="button"
          className="oosv2-contrato-venc-btn"
          onClick={v.closeContratoVencModal}
        >
          Entendi
        </button>
      </div>
    </div>
  );
}
